import { getAuthenticatedBackendClient } from "../../api/backend.api.js";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { useRecordContext } from "react-admin";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { useEffect, useState } from "react";
import { PageTitle } from "../../misc/PageTitle.js";
import { Button, Typography } from "@mui/material";
import AddCardIcon from "@mui/icons-material/AddCard";

export function DrivingSchoolPlatformPayments() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const [companySetupUrl, setCompanySetupUrl] = useState<string | null>(null);
  const drivingSchoolId = drivingSchool?.id;
  const hasUseStripeForB2BPayments = drivingSchool?.customizations?.includes("useUseStripeForB2BPayments");

  useEffect(() => {
    if (!drivingSchoolId || !hasUseStripeForB2BPayments) {
      return;
    }
    const fetchCompanySetupUrl = async () => {
      try {
        const backendClient = await getAuthenticatedBackendClient();
        const resp = await backendClient.companySetup.companySetupGetStripeSetupUrlRetrieve({
          drivingSchoolId,
        });
        setCompanySetupUrl(resp.setup_url);
      } catch (error) {
        handleError(`Error fetching company setup URL`, error);
        setCompanySetupUrl("ERROR");
      }
    };
    void fetchCompanySetupUrl();
  }, [drivingSchoolId, hasUseStripeForB2BPayments]);

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Platform Zahlungen</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  if (!hasUseStripeForB2BPayments) {
    return (
      <>
        <PageTitle>Platform Zahlungen</PageTitle>
        <Typography>Diese Funktion ist für diese Fahrschule nicht aktiviert.</Typography>
      </>
    );
  }

  return (
    <div>
      <h1>Platform Zahlungen</h1>
      <p>Hier kann ein Zahlungsmittel für die Zahlungen der Plattform konfiguriert werden.</p>
      {companySetupUrl === null ? (
        <LoadingIndicator />
      ) : companySetupUrl === "ERROR" ? (
        <p>Fehler beim Abrufen der Setup-URL. Bitte versuchen Sie es später erneut.</p>
      ) : (
        <Button
          variant="outlined"
          startIcon={<AddCardIcon />}
          component="a"
          href={companySetupUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Zahlungsmittel konfigurieren
        </Button>
      )}
    </div>
  );
}

export default DrivingSchoolPlatformPayments;
